// extracted by mini-css-extract-plugin
module.exports = {"gallery":"home-hero_gallery__1JAG5"};